import React from "react";
import { motion } from "framer-motion";
import { KineticText } from "@/lib/motion";
import { useAdaptiveHero } from "@/lib/useAdaptiveHero";

export const PageHero = ({ eyebrow, lines, sub, image, imagePosition = "center", children, tall = false, fill = false }) => {
  const { ref, height } = useAdaptiveHero(fill ? null : image, {
    mobileMinVh: tall ? 80 : 70,
    desktopMinVh: tall ? 68 : 56,
  });
  const fallback = fill ? "h-full" : tall ? "min-h-[82vh]" : "min-h-[62vh]";
  const adaptive = !fill && height;

  return (
    <section
      ref={ref}
      data-testid="page-hero"
      className={`relative ${adaptive ? "" : fallback} flex items-end sm:items-center overflow-hidden bg-forestdeep`}
      style={adaptive ? { height: `${height}px` } : undefined}
    >
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover" style={{ objectPosition: imagePosition }} />
        <div className="absolute inset-0 bg-gradient-to-t from-forestdeep/75 via-forestdeep/25 to-forestdeep/10" />
        <div className="absolute inset-y-0 left-0 w-full lg:w-1/2 bg-gradient-to-r from-forestdeep/45 via-forestdeep/15 to-transparent" />
      </div>
      <div className="relative container-nb py-20 sm:py-28 w-full [text-shadow:0_2px_22px_rgba(0,0,0,0.6)]">
        {eyebrow && (
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="eyebrow !text-[#F2D27C] !font-bold mb-5 inline-flex items-center gap-3 before:content-[''] before:h-px before:w-8 before:bg-[#F2D27C]"
            data-testid="page-hero-eyebrow"
          >
            {eyebrow}
          </motion.p>
        )}
        <KineticText
          lines={lines}
          className="font-serif text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-cream leading-[1.08] tracking-tight max-w-4xl"
        />
        {sub && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
            className="mt-6 text-cream text-base sm:text-lg max-w-xl leading-relaxed"
            data-testid="page-hero-sub"
          >
            {sub}
          </motion.p>
        )}
        {children && (
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.85 }} className="mt-8">
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
};
